module.exports = __webpack_public_path__ + "img/library_system-min.3e3bcc5b.png";